import { routesConfig } from './config';
import { path, sitePath, teamPath } from './path-helpers';

export { AppRoutes } from './AppRoutes';
export * from './types';

export const Router = {
  routes: routesConfig,
  path,
  sitePath,
  teamPath,
};
